/* eslint-disable no-restricted-globals */
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { Container } from './styles';
import UsuarioService from '../../services/UsuarioService';
import AuthService from '../../services/AuthService';
import { showMessage } from '../../components/MessageDialog';
import { errorHandle } from '../../util/functions';

import history from '../../services/history';

export default function VincularTelegram() {
  const [token, setToken] = useState('');
  const [timeExpired, setTimeExpired] = useState(0);
  const [processando, setProcessando] = useState(false);
  const [registroCompleto, setRegistroCompleto] = useState(false);

  // refs para evitar stale state dentro do setInterval
  const intervalRef = useRef(null);
  const timeRef = useRef(0);
  const processandoRef = useRef(false);

  // mantém refs sincronizados com state
  useEffect(() => {
    timeRef.current = timeExpired;
  }, [timeExpired]);

  useEffect(() => {
    processandoRef.current = processando;
  }, [processando]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const registraChatId = async () => {
    let usuario;
    try {
      usuario = await UsuarioService.findById(AuthService.getUsuario().id);
    } catch (err) {
      //
    }

    if (usuario && usuario.colaborador && usuario.colaborador.telegramChatId) {
      showMessage(
        'Confirmação',
        'Usuário já possui telegram registrado. Deseja substituir?',
        idx => {
          if (idx === 1) {
            requestRegisterChatId();
          }
        }
      );
    } else {
      requestRegisterChatId();
    }
  };

  const requestRegisterChatId = async () => {
    try {
      const retorno = await UsuarioService.requestRegisterChatId();

      setToken(retorno.token);
    } catch (error) {
      errorHandle(error);
    }
  };
  const verificaRegistro = useCallback(async () => {
    try {
      try {
        setProcessando(true);
        await UsuarioService.registerChatIdByToken(token);
        return true;
      } catch (err) {
        return false;
      }
    } finally {
      setProcessando(false);
    }
  }, [token]);

  const cancelar = useCallback(() => {
    // limpa o interval de forma confiável
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    setTimeExpired(0);
    setToken('');
  }, []);

  const iniciaTimer = useCallback(
    async tempoInicial => {
      // se já existir timer, zera antes
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      setRegistroCompleto(false);
      setTimeExpired(tempoInicial);
      timeRef.current = tempoInicial;

      intervalRef.current = setInterval(async () => {
        // decrementa usando a ref como "fonte da verdade"
        const proximo = timeRef.current - 1;
        timeRef.current = proximo;
        setTimeExpired(proximo);

        // condição de expiração
        if (proximo <= 0) {
          cancelar();
          return;
        }

        // a cada 5s, se não estiver processando, verifica
        if (!processandoRef.current && proximo % 5 === 0) {
          try {
            const retorno = await verificaRegistro();
            if (retorno) {
              cancelar();
              toast.success('Usuário registrado com sucesso!');
              setRegistroCompleto(true);
            }
          } catch (e) {
            // opcional: tratar erro de rede
            // console.error(e);
          }
        }
      }, 1000);
    },
    [cancelar, verificaRegistro]
  );

  const abrirTelegram = useCallback(async () => {
    const payload = encodeURIComponent(token);
    const tgUrl = `tg://resolve?domain=SpeedySistemasBot&start=${payload}`;
    // const webUrl = `https://t.me/SpeedySistemasBot?start=${payload}`;

    location.href = tgUrl;
    setTimeExpired(60);

    iniciaTimer(60);
  }, [iniciaTimer, token]);

  return (
    <Container className="p-grid">
      <div className="p-col-12 p-lg-12 p-fluid" style={{ marginBottom: 10, marginTop: 10 }}>
        <h1 style={{ color: 'black', fontWeight: 'bold', textAlign: 'center' }}>
          Vincular Telegram
        </h1>
      </div>
      <div className="p-col-12" />
      {!registroCompleto ? (
        <>
          {token === '' ? (
            <div className="p-col-12" style={{ textAlign: 'center' }}>
              <Button
                className="p-button-primary"
                label="Registrar"
                icon="pi pi-fw pi-link"
                onClick={() => registraChatId()}
              />
            </div>
          ) : null}
          {token !== '' && timeExpired === 0 ? (
            <div className="p-col-12" style={{ textAlign: 'center' }}>
              <Button
                className="p-button-primary"
                label="Abrir Telegram"
                onClick={() => abrirTelegram()}
              />
            </div>
          ) : null}
          {timeExpired > 0 ? (
            <div className="p-col-12" style={{ textAlign: 'center' }}>
              Token: <b>{token}</b> gerado com sucesso!
              <p>
                Após o telegram ser aberto, aguarde um instante para que o processo seja
                finalizado...
              </p>
              <p />
              <p>Processo expira em {timeExpired}s</p>
            </div>
          ) : null}
          {timeExpired !== 0 ? (
            <div className="p-col-12" style={{ textAlign: 'center' }}>
              <Button
                className="p-button-danger"
                label="Cancelar"
                onClick={() => cancelar()}
              />
            </div>
          ) : null}
        </>
      ) : (
        <>
          <div className="p-col-12" style={{ textAlign: 'center' }}>
            Registro realizado com sucesso <p />
          </div>

          <div className="p-col-12" style={{ textAlign: 'center' }}>
            <Button
              className="p-button-secondary"
              label="Voltar"
              onClick={() => history.push('/home')}
            />
          </div>
        </>
      )}
    </Container>
  );
}
